import {
  FETCH_LOCALITIES_REQUEST,
  FETCH_LOCALITIES_SUCCESS,
  FETCH_LOCALITIES_FAILURE
} from '../actions/localityActions';

const initialState = {
  loading: false,
  localities: [],
  district: '',
  state: '',
  error: ''
};

const localityReducer = (state = initialState, action) => {
  switch (action.type) {
      case FETCH_LOCALITIES_REQUEST:
          return {
              ...state,
              loading: true,
              district: '',
              state: '',
              error: ''
          };
      case FETCH_LOCALITIES_SUCCESS:
          return {
              ...state,
              loading: false,
              localities: action.payload?.localities || [],
              district: action.payload?.district || '',
              state: action.payload?.state || '',
              error: ''
          };
      case FETCH_LOCALITIES_FAILURE:
          return {
              ...state,
              loading: false,
              localities: [],
              district: '',
              state: '',
              error: action.payload
          };
      default:
          return state;
  }
};

export default localityReducer;
